/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable max-len */
import { Injectable, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { API_ENDPOINT } from '../../../../environments/environment';
import { AuthenticationMethod } from '../../../enums/authentication-method';
import { UserService } from '../../api/user.service';
import { AlertService } from '../utils/alert.service';
import { DeviceConfiguration } from '../../../models/device-configuration';
import { Action } from '../../../enums/action';
const COMPANY_KEY = 'company';
const WORKPLACE_KEY = 'workplace';
const WORKPLACE_CODE_KEY = 'workplace-code';
const DEFAULT_LANGUAGE = 'ca';
const ADMIN_TOKEN = 'token';
const EXIST_FINGERPRINT_SENSOR = 'exist_fingerprint_sensor';
const DEVICE_TOKEN = 'device_token';
const DEVICE_CONFIGURATION = 'device_configuration';
import { Device } from '@capacitor/device';
import { App } from '@capacitor/app';
import { AnalyticsService } from '../analytics/analytics.service';

@Injectable({
  providedIn: 'root'
})
export class EnvService {

  constructor(
    private injector: Injector,
    private translateService: TranslateService,
    private alertService: AlertService
  ) { }

  async getVersion(): Promise<string> {
    return new Promise(async (resolve, reject) => {
      const info = await App.getInfo();
      resolve(info.version);
    });
  }

  async getDeviceInfo(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      const deviceId = await Device.getId();
      const deviceInfo = await Device.getInfo();
      resolve(Object.assign({ uuid: deviceId.identifier }, deviceInfo));
    });
  }

  getApiUrl() {
    return API_ENDPOINT.replace('{company}', localStorage.getItem('company'));
  }

}
